import { render, staticRenderFns } from "./ProductLabelEdit.vue?vue&type=template&id=0981e6bd&"
import script from "./ProductLabelEdit.vue?vue&type=script&lang=js&"
export * from "./ProductLabelEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports